import React from 'react';
import { Button, cn, IconHome, Typography } from '../index';

export type TBreadcrumbContent = {
  text: string;
  slug: string;
}

export type TBreadcrumbProps = {content: TBreadcrumbContent[], className?: string, textClassName?: string,}

export const Breadcrumb = ({ content, className, textClassName }: TBreadcrumbProps): JSX.Element => {
  return (
    <nav className={className}>
      <ul className='flex flex-row gap-1.5 text-text-light font-semibold items-center p-1.5'>
        <li>
          <Button
            className={cn('block p-0 no-underline text-text-light hover:text-text active:text-text', textClassName)}
            variant='link'
            to='/'
          >
            <IconHome className='size-5 block'/>
          </Button>
        </li>
        {content.map((p: any, index: number) => (
          <React.Fragment key={index}>
            <li className = {cn(
              'hidden md:flex flex-row gap-1.5 items-center',
              index === content.length - 1 ? 'flex' : '',
              index === 0 ? 'flex' : '',
            )}>
              <Typography color='text' size='xs' className={textClassName}>/</Typography>
              {index == (content.length - 1)
                ? (
                  <Typography weight='semibold' size='xs' className={textClassName}>{p.text}</Typography>
                )
                : (
                  <Button
                    className={cn('p-0 block border-text-light text-light hover:underline hover:[text-shadow:_1px_0_0] hover:text-text', textClassName)}
                    variant='link'
                    to={p.slug}
                  >
                    <Typography weight='semibold' size='xs'><span className='hidden md:flex'>{p.text}</span><span className='md:hidden'>...</span></Typography>
                  </Button>
                )
              }
            </li>
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
};
